import { SafeUrl } from '@angular/platform-browser';

export interface IHitsInterface {
  hotlist_id: string;
  source: string;
  reason: string;
  comment: string;
}

export interface IMediaInterface {
  url: string | SafeUrl;
  thumbnailUrl: string | SafeUrl;
  type: string;
}

export interface IFsLprQueryResultInterface {
  id: string;
  provider: string;
  organization_id: string;
  camera_id: string;
  camera_name: string;
  created_timestamp: string;
  event_timestamp: string;
  plate: string;
  plate_confidence: number;
  plate_state: string;
  plate_state_confidence: string;
  hits: IHitsInterface[];
  media: IMediaInterface[];
  details: object;
  geometry: {
    lat: number;
    lon: number;
  };
  vehicle_color: string;
  vehicle_color_confidence: number;
  vehicle_make: string;
  vehicle_make_confidence: number;
  vehicle_model: string;
  vehicle_model_confidence: number;
  vehicle_year: string;
  vehicle_year_confidence: number;
  vehicle_body_type: string;
  vehicle_body_type_confidence: number;
  coded_values: object;
  event_date: string;
  is_hit: boolean;
}
